export const APP = {
  serverUrl: process.env.SERVER_URL,
  language: 'en', // en/vn
  pageSize: 5,
  pageNumber: 1
};
